import { render } from "./saved-replies.vue?vue&type=template&id=187ea481&scoped=true"
import script from "./saved-replies.vue?vue&type=script&lang=js"
export * from "./saved-replies.vue?vue&type=script&lang=js"

import "./saved-replies.vue?vue&type=style&index=0&id=187ea481&lang=scss&scoped=true"
import "./saved-replies.vue?vue&type=style&index=1&id=187ea481&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187ea481"]])

export default __exports__